import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ComponentsModule } from '@nx-customer-apps/components';

@Component({
    selector: 'vp-error-404',
    templateUrl: './error-404.component.html',
    styleUrls: ['../errors.scss'],
    imports: [MatButton, RouterLink, ComponentsModule, TranslatePipe]
})
export class Error404Component {}
